export default {
  popper: {
    ".RlxHelp-tooltip": {
      h4: {
        margin: "0 0 calc(0.5 * var(--rhythm)) 0",
        fontWeight: 600,
      },
      ul: {
        margin: 0,
        padding: 0,
        listStyle: "none",
      },
      li: {
        margin: 0,
        marginBottom: "calc(0.25 * var(--rhythm))",
        padding: 0,
      },
      sup: {
        verticalAlign: "middle",
        color: "var(--color-red)",
      },
      mark: {
        display: "block",
        marginTop: "calc(0.5 * var(--rhythm))",
        color: "var(--color-white)",
        backgroundColor: "transparent",
      },
    },
  },
};
